import { render } from "./MemberProfile.vue?vue&type=template&id=1b80868a&scoped=true"
import script from "./MemberProfile.vue?vue&type=script&lang=js"
export * from "./MemberProfile.vue?vue&type=script&lang=js"

import "./MemberProfile.vue?vue&type=style&index=0&id=1b80868a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b80868a"]])

export default __exports__